import React, { Component,Fragment } from 'react';
import './AdminTransactions.css';

import NabarAdmin from '../Components/NabarAdmin/NabarAdmin';
import AdminHeaderTool from '../Components/AdminHeaderTool/AdminHeaderTool';
import axios from 'axios'
import { LinkAPI } from '../../../API/API'
import HandleRes from '../../Components/HandleRes/HandleRes';
var moment = require('moment');

class AdminTransaction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            datatransactions: [],
            failedreason: "",
            status:"0",
            currentPage: 1, 
            transactionsPerPage: 8,
            networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError: false,
        };
        this.handleClick = this.handleClick.bind(this);
        this.gettransactions()
    }
    
    gettransactions = () => {

        const Token = localStorage.getItem("AdminTokenKayn")
        axios.get(`${LinkAPI}/api/admin/gettransactions`, {
            headers: {
                Authorization: `${Token}`
            }
        }).then(res => {
            this.setState({
                datatransactions: res.data.reverse(),
                networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError: false,
            })
        }).catch(error => {
            this.HandleError(error)
        })
    }
    HandleError = (error) => {
        if (!error.response) {
            this.setState({
                networkError: true
            })
        } else if (error.response.status === 402) {
            window.location.replace("/Admin/SignIn");
        } else if (error.response.data.message) {
            this.setState({
                errordatamessage: true,
                errordatamessagetext: error.response.data.message,
                failedreasonerror: '',
            })
        } else {
            this.setState({
                hasError: true,
            })
        }
    }
    
    handleClick(event) {
        this.setState({
            currentPage: Number(event.target.value)
        });
    }
    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value,
        });

    };
    completetransaction = event => {
        const x = event.target.id
        const Token = localStorage.getItem("AdminTokenKayn")
        axios.post(`${LinkAPI}/api/admin/completetransaction`, { id: x }, {
            headers: {
                Authorization: `${Token}`
            }
        }).then(res => {
            this.setState({
                donetrans:true,
                resdatamessagetext: res.data.message,

                networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError: false,
            })
            this.gettransactions()

            setTimeout(() => {
                this.setState({
                    donetrans:false
                })
        }, 2000);
            }).catch(error => {
                this.HandleError(error)
            })
    }
    failedtransaction = event => {
        const { failedreason } = this.state
        const x = event.target.id
        const Token = localStorage.getItem("AdminTokenKayn")
        axios.put(`${LinkAPI}/api/admin/failedtransaction`, { id: x, failedreason: failedreason }, {
            headers: {
                Authorization: `${Token}`
            }
        }).then(res => {
            this.setState({
                donetrans:true,
                resdatamessagetext: res.data.message,
                networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError: false,
            })
            this.gettransactions()

            setTimeout(() => {
                this.setState({
                    donetrans:false
                })
        }, 2000);
        }).catch(error => {
            this.HandleError(error)

        })
    }
    render() {

        let  datatransactions = this.state.datatransactions.filter(
            (contact)=>{
                return contact.status.toString().indexOf(this.state.status.toString())!==-1;
            }
        )
        const {  currentPage, transactionsPerPage } = this.state;
        // Logic for displaying current todos
        const indexOfLasttransactions = currentPage * transactionsPerPage;
        const indexOfFirsttransactions = indexOfLasttransactions - transactionsPerPage;
        const currentdatatransactions = datatransactions.slice(indexOfFirsttransactions, indexOfLasttransactions);
        const renderdatatransactions = currentdatatransactions.map((x, i) => {
            
            const handelstutes = ["PENDING", "COMPLETED", "DENCILE"]
            return <div className="col-md-8  mx-auto border shadow itemTransaction rounded my-3" key={i}>
                <div className="row px-2 py-3">
                    <div className="row col-md-10">
                        <p className="fontsize11 col-md-2 bluecolor font-weight-bold">ID</p><p className="fontsize11 col-md-10">{x.id}</p>
                        <p className="fontsize11 col-md-2 bluecolor font-weight-bold">Account </p><p className="fontsize11 col-md-10">{x.bankaccount.accountname}</p>
                        <p className="fontsize11 col-md-2 bluecolor font-weight-bold">Amount</p><p className="fontsize11 col-md-10">{x.amount}</p>
                        <p className="fontsize11 col-md-2 bluecolor font-weight-bold">Bank</p><p className="fontsize11 col-md-10">{x.bankaccount.bankname}</p>
                        <p className="fontsize11 col-md-2 bluecolor font-weight-bold">Bank Number</p><p className="fontsize11 col-md-10">{x.bankaccount.accountnumber}</p>
                        <p className="fontsize11 col-md-2 bluecolor font-weight-bold ">Date</p><p className="fontsize11 col-md-10">{ moment(x.date).format("ll")}</p>
                        <p className="fontsize11 col-md-2 bluecolor font-weight-bold ">Status</p><p className="fontsize11 col-md-10">{handelstutes[x.status]}</p>
                        {(x.status===2?<><p className="fontsize11 col-md-2 bluecolor font-weight-bold">Reason</p><p className="fontsize11 col-md-10">{x.failedreason}</p></>:'')}
                        {/* {failedreason} */}
                    </div>
                    <div className="col-md-2 text-center d-flex align-content-around flex-wrap" >
                        {(x.status!==1?
                        <Fragment>
                        <button className="btn btn-primary badge-pill" id={x.id} onClick={this.completetransaction}>completed</button>
                        </Fragment>:'')}

                        {(x.status===0?
                        <Fragment>
                        <button className="btn border   btn-block p-1 badge-pill text-danger" data-toggle="modal" data-target={"#exampleModal" + x.id}>DECLINE</button>
                        <div className="modal fade" id={"exampleModal" + x.id} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <p className="fontsize11  ">Add Reason of Dencile</p>
                                        <textarea className="form-control rounded" placeholder="Add Reason" row="3" required name="failedreason" onChange={this.handleChange}></textarea>
                                    </div>
                                    <div className="modal-footer p-3">
                                        <button type="button" className="btn border shadow  badge-pill " data-dismiss="modal">Close</button>
                                        <button type="button" className="btn btn-primary badge-pill" id={x.id} onClick={this.failedtransaction} data-dismiss="modal">Save changes</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </Fragment>:'')}

                    </div>
                </div>
            </div>
        });

        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(datatransactions.length / transactionsPerPage); i++) {
            pageNumbers.push(i);
        }
        const renderPageNumbers = pageNumbers.map(number => {
            return (<li className={" page-item page-link pointer px-0 " + (this.state.currentPage=== number? 'pageNumbers border' : '')} key={number} value={number} onClick={this.handleClick}>{number}</li>);
        });
        return (
            <div>

                <div className="row AppEN  mx-0">
                    <div className="col-md-1 px-0 ">
                        <NabarAdmin />
                    </div>
                    <div className=" AdminTransaction Admin col-md-11 px-4">
                        <AdminHeaderTool />
                        <div className="">
                            <h3 className=" fontsize9 my-3">Transaction</h3>
                            <div className="filter px-4 row"> 
                                <p className="fontsize11 font-weight-bold mt-2 col-lg-1 col-md-2">View</p>
                                    <div className="col-lg-2 col-md-5">
                                        <div className="form-group  ">
                                        <select id="inputState" className="form-control  badge-pill  text-muted" name="status" onClick={this.handleChange}>
                                                <option value="0" >PENDING</option>
                                                <option value="1">COMPLETED</option>
                                                <option value="2">DECLINE</option>

                                            </select>
                                        </div>
                                    </div>
                                
                               
                            </div>
                            {renderdatatransactions}

                        </div>
                        <nav aria-label="Page navigation example">
                            <ul className="pagination justify-content-center">
                                {renderPageNumbers}
                            </ul>
                        </nav>
                    </div>
                </div>
                {(this.state.donetrans ? <HandleRes  title={this.state.resdatamessagetext} stylecss="alert-success" /> : '')}
                {(this.state.networkError ? <HandleRes title="You are currently offline."resdatamessagetext stylecss="alert-danger" /> : '')}
                {(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default AdminTransaction;